import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import { setNumberOfAdults, setNumberOfChildren, setNumberOfInfants, setNumberOfPets, setDateBookingMade,
         setElectricCarCharging, setTravelCotRequired, setHighChairRequired, setPage,
         setTotalAmount, setDeposit } from '../../store/AppSlice';
import '../../css/base.css';
import scenery5_large from '../../img/scenery5_large.jpg';

const YourParty = () => {

  const dispatch = useDispatch();
  const appstate = useSelector((state) => state.appState);

  useEffect(() => {
    dispatch(setDateBookingMade(format(new Date(), "yyyyMMdd")));
    window.scrollTo(0,0);

  })

  const getNumberOfChildrenOptions = () => {

    const { numberOfAdults } = appstate.bookingDetails;

    let noOfChildrenAllowed = 5 - numberOfAdults;

    if (noOfChildrenAllowed == 0) {
      return (<Fragment>
        <option>0</option>
      </Fragment>)
    }
    
    if (noOfChildrenAllowed == 1) {
      return (<Fragment>
        <option>0</option>
        <option>1</option>
      </Fragment>)
    }

    if (noOfChildrenAllowed == 2) {
      return (<Fragment>
        <option>0</option>
        <option>1</option>
        <option>2</option>
      </Fragment>)
    }

    if (noOfChildrenAllowed == 3) {
      return (<Fragment>
        <option>0</option>
        <option>1</option>
        <option>2</option>
        <option>3</option>
      </Fragment>)
    }

    if (noOfChildrenAllowed == 4) {
      return (<Fragment>
        <option>0</option>
        <option>1</option>
        <option>2</option>
        <option>3</option>
        <option>4</option>
      </Fragment>)
    }
  }

  const { bookingDetails } = appstate; 

  return (
    <div className="row">
      <div className="col-12 col-md-6 imagesBackgroundColour">
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="keyText">
              <h4 className="availabilityCalendarTextBox">Your Party<span style={{"fontSize": "0.8rem"}}>&nbsp; &nbsp;&nbsp;(1 of 4)</span></h4>
            </div>            
          </div>
        </div>          

        <div className="row" style={{"marginTop": "1rem"}}>
          <div className="col-12 col-sm-5">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="no-of-adults" className="label-text">Number of adults:
                </label>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-7">
            <div>
              <select className="duration-select input-text" value={bookingDetails.numberOfAdults} name="no-of-adults" id="no-of-adults"
                  onChange={(event) => {dispatch(setNumberOfAdults(event.target.value))}}>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
              </select>
              </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-sm-5">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="no-of-children" className="label-text">Number of children:
                </label>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-7">
            <div>
              <select className="duration-select input-text" value={bookingDetails.numberOfChildren} name="no-of-children" id="no-of-children"
                  onChange={(event) => {dispatch(setNumberOfChildren(event.target.value))}}>
                  {getNumberOfChildrenOptions()}
              </select>
              </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-sm-5">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="no-of-infants" className="label-text">Number of infants:
                </label>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-7">
            <div>
              <select className="duration-select input-text" value={bookingDetails.numberOfInfants} name="no-of-infants" id="no-of-infants"
                  onChange={(event) => {dispatch(setNumberOfInfants(event.target.value))}}>
                  <option>0</option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
              </select>
              </div>
          </div>
        </div>

        <div className="row" style={{"marginTop": "0.2rem"}}>
          <div className="col-12 col-sm-5">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="no-of-pets" className="label-text">Number of pets:
                </label>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-7">
            <div>
              <select className="duration-select input-text" value={bookingDetails.numberOfPets} name="no-of-pets" id="no-of-pets"
                  onChange={(event) => {dispatch(setNumberOfPets(event.target.value))}}>
                  <option value="0">0</option>
                  <option value="1">1 +£30</option>
                  <option value="2">2 +£60</option>
              </select>
              </div>
          </div>
        </div>

        <div className="row" style={{"marginTop": "0.2rem"}}>
          <div className="col-12 col-sm-5">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="electric-car-charging" className="label-text">Electric Car Charging +£50:
                </label>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-7">
            <div>
              <input type="checkbox" className="custom-tick-box" id="electric-car-charging" name="electric-car-charging" 
                      defaultChecked={bookingDetails.electricCar} onChange={(e) => {dispatch(setElectricCarCharging(e.target.checked))}}/>
            </div>
          </div>
        </div>

        <div className="row" style={{"marginTop": "0.2rem"}}>
          <div className="col-12 col-sm-5">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="highchair-required" className="label-text">Highchair (FREE):
                </label>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-7">
            <div>
              <input type="checkbox" className="custom-tick-box" id="highchair-required" name="highchair-required"
                      defaultChecked={bookingDetails.highChairRequired} onChange={(e) => {dispatch(setHighChairRequired(e.target.checked))}}
              />
            </div>
          </div>
        </div>

        <div className="row" style={{"marginTop": "0.2rem"}}>
          <div className="col-12 col-sm-5">
            <div className="generalText">
              <div className="generalTextBox">
                <label htmlFor="travelcot-required" className="label-text">Travel Cot (FREE):
                </label>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-7">
            <div>
              <input type="checkbox" className="custom-tick-box" id="travelcot-required" name="travelcot-required"
                      defaultChecked={bookingDetails.cotRequired} onChange={(e) => {dispatch(setTravelCotRequired(e.target.checked))}}/>
            </div>
          </div>
        </div>

        <div className="row">
        <div className="col-5 back-btn-col" style={{"paddingLeft": "15px"}}>
            <p className="back-button">
              <span className="navigate-span">
                <a className="your-details-button" onClick={() => { dispatch(setPage("BOOKING"))}}>Back</a>
              </span>
            </p>
          </div>          
          <div className="col-6 selected-week-book-btn-col">
            <p className="book-selected-date-button">
              <span className="navigate-span">
                <a className="your-details-button" onClick={() => { dispatch(setTotalAmount(bookingDetails.rate + bookingDetails.petPayment + bookingDetails.carChargingPayment));
                                                                    dispatch(setDeposit((bookingDetails.rate + bookingDetails.petPayment + bookingDetails.carChargingPayment)*0.25));
                                                                    dispatch(setPage("YOUR_DETAILS"))}}
                                                                    >Continue</a>
              </span>
            </p>
          </div>          
        </div>
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour">
        <img src={scenery5_large} alt="Welcome Door" className="gallery-image" />
      </div>
    </div>
  );
}

export default YourParty